import React, { useEffect, useRef } from 'react';
import '../styles/AboutUsSlot.css';
import aboutImage from '../assets/aboutusslot.png';

const AboutUsSlot = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current.querySelectorAll('.animate-text');
    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className="aboutus-slot" ref={sectionRef}>
      <div className="aboutus-content animate-text">
        <h2>Ride, Connect, and Explore</h2>
        <p>
          Imagine a city where every ride is an opportunity to meet new people. SHADE is designed to create a community
          of like-minded individuals who share rides, stories, and experiences while making travel more enjoyable.
        </p>

        <h2>A Mission for a Cleaner Tomorrow</h2>
        <p>
          Our goal is to remove the maximum number of unnecessary vehicles from the roads, making cities safer, quieter,
          and more efficient. With strategically placed bikes and an easy-to-use app, SHADE is making sustainable
          transport the preferred choice.
        </p>

        <p className="join-text">
          Join SHADE today—ride, connect, and be a part of the movement for a cleaner, friendlier, and greener world!
        </p>
      </div>

      <div className="aboutus-image animate-text">
        <img src={aboutImage} alt="About Us" />
      </div>
    </div>
  );
};

export default AboutUsSlot;
